import {USRE_INFO_LOAD, GET_LOTTERY_HISTORY, ADD_LOTTERY_CHANCE, GET_REMAIN_TIMES} from '../constant/eventbus'
import {getJSON} from '../api/myaxios'
import {error_event} from "../tools/mgtv/analysis";
import preload from "../tools/preload";


function fetch_remain_times() {
  getJSON(`//vipact3.api.mgtv.com/api/v1/act/lot/chance/get`, {
    ticket: window.$bus.user.ticket,
    act_name: window.rootdata.act_name,
    t: new Date().getTime()
  }).then(res => {
    if (res && res.ret === 0) {
      window.$bus.lottery.remain_chance = res.data.times;
    }
  })
}

function get_lottery_history(EventBus) {
  getJSON('//vipact3.api.mgtv.com/api/v1/act/lot/records', {
    ticket: window.$bus.user.ticket,
    act_name: window.rootdata.act_name,
    offset: 0,
    count: 100,
    t: new Date().getTime()
  }).then(res => {
    console.log('get_lottery_history', res);

    if (!res) {
      window.$toast('请求超时，请重试');
      return;
    }
    if (res.ret === 0) {
      if (!res.data.list) {
        return;
      }
      const records = res.data.list.filter(item => {
        return item.award_type > 0
      });

      EventBus.$set(EventBus.lottery, 'lottery_history', records);
    }
  })
}


function add_lottery_chance(EventBus) {
  getJSON('//vipact3.api.mgtv.com/api/v1/act/lot/chance/add', {
    ticket: window.$bus.user.ticket,
    act_name: window.rootdata.act_name,
    come_from: 'share'
  }).then(res => {
    console.log('add_lottery_chance', res)

    if (!res) {
      return;
    }
    if (res.ret === 0) {
      //成功增加了抽奖机会，对抽奖机会进行更新
      EventBus.$set(EventBus.lottery, 'remain_chance', res.data.times);
    }
  })
}

function preloadPrize() {
  //获取奖品信息，预加载奖品图片
  getJSON("//vipact3.api.mgtv.com/api/v1/act/lot/award/list", {act_name: window.rootdata.act_name}).then(res => {
    console.log('preloadPrize', res)
    if (res && res.ret === 0) {
      const imgs = res.data.list.map(item => {
        return item.icon;
      })
      preload(imgs);
    }
  })
}

function isLottery() {
  let res = false;
  if (!window.$bus.tpl) {
    return res;
  }
  window.$bus.tpl.comps.forEach(item => {
    switch (item.type) {
      case 'LotteryRemainTimes':
      case 'CardLottery':
      case 'ScratcherLottery':
      case 'ActLotteryNine':
      case 'ActLotteryCycle':
        res = true
        break;
      default:
        break;
    }
  })
  console.log('is_lottery', res);
  return res
}

export default {
  install: function (EventBus) {
    EventBus.$on(USRE_INFO_LOAD, () => {
      //
      // setTimeout(()=>{
      //   if (!isLottery()) {
      //     return;
      //   }
      //   get_lottery_history(EventBus);
      //   fetch_main_times().then(res => {
      //     if (res && res.ret === 0) {
      //       EventBus.$set(EventBus.lottery, 'remain_chance', res.data.times);
      //     }
      //   });
      // },1000);
      // preloadPrize();

    });


    EventBus.$on(GET_REMAIN_TIMES, () => {
      if (!window.$bus.user.uuid) {
        return;
      }
      fetch_remain_times();
    });

    EventBus.$on(GET_LOTTERY_HISTORY, () => {
      if (!isLottery() || !window.$bus.user.uuid) {
        return;
      }
      get_lottery_history(EventBus);
    });

    EventBus.$on(ADD_LOTTERY_CHANCE, () => {
      if (!isLottery() || !window.$bus.user.uuid) {
        return;
      }
      add_lottery_chance(EventBus);
    });

  }


}





// WEBPACK FOOTER //
// ./src/EventBus/EventLottery.js